import { createContext } from "react";
import type { UserType } from "@/types/graphql/partner";

interface AuthContextType {
  user: UserType;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
